import { render, staticRenderFns } from "./FilesUpload.vue?vue&type=template&id=79a87a37&scoped=true&"
import script from "./FilesUpload.vue?vue&type=script&lang=ts&"
export * from "./FilesUpload.vue?vue&type=script&lang=ts&"
import style0 from "./FilesUpload.vue?vue&type=style&index=0&id=79a87a37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a87a37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79a87a37')) {
      api.createRecord('79a87a37', component.options)
    } else {
      api.reload('79a87a37', component.options)
    }
    module.hot.accept("./FilesUpload.vue?vue&type=template&id=79a87a37&scoped=true&", function () {
      api.rerender('79a87a37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/files/FilesUpload.vue"
export default component.exports